import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { QrCodeGuard } from './guard/qrcode.guard';
import { RedirectGuard } from './guard/redirect.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'panel' },
  {
    path: 'panel',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/panel.module').then(m => m.PanelPageRoutingModule),
  },
  {
    path: 'retiree',
    canActivate: [AuthGuard],
    loadChildren: () => import('./retiree/retiree.module').then(m => m.RetireeModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'sso/transition',
    loadChildren: () => import('./pages/sso-transition/sso-transition.module').then(m => m.SsoTransitionPageModule),
  },
  {
    path: 'sso/callback',
    loadChildren: () => import('./pages/sso-callback/sso-callback.module').then(m => m.SsoCallbackPageModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'confirmEmail/:token',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'session-expired',
    loadChildren: () => import('./pages/session-expired/session-expired.module').then(m => m.SessionExpiredPageModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule),
  },
  {
    path: 'email-signature',
    loadChildren: () =>
      import('./pages/user/email-signature/email-signature.module').then(m => m.EmailSignaturePageModule),
  },
  {
    path: 'qrcode/:id',
    canActivate: [AuthGuard, QrCodeGuard],
  },
  {
    path: 'redirect/:id',
    canActivate: [AuthGuard, RedirectGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
